import * as React from 'react';

import { WalkScoreViewModel, WhatsAroundModuleViewModel } from 'models';

import { UitkCardTextSegment } from 'uitk-react-cards';

import { NearbyList } from './nearby-list';
import { NearbyPOIs } from './nearby-pois';
import { NearbyRestaurants } from './nearby-restaurants';
import { NearbyTransportation } from './nearby-transportation';

interface WhatsAroundContentProps {
  className?: string;
  model?: WhatsAroundModuleViewModel;
  walkScoreModel?: WalkScoreViewModel;
}

export const WhatsAroundContent: React.FunctionComponent<WhatsAroundContentProps> = ({ className, model, walkScoreModel }) => {
  const nearbyPOIs = model.nearbyPOIs && model.nearbyPOIs.length >= 1;
  const nearbyTransportation = model.nearbyTransportation && model.nearbyTransportation.length >= 1;
  const nearbyRestaurants = model.restaurants && model.restaurants.length >= 1;

  return (
    <div className={`${className}`}>
      {(nearbyPOIs || nearbyTransportation || nearbyRestaurants) && (
        <UitkCardTextSegment className="whats-around__nearby">
          {nearbyPOIs && (
            <NearbyList outerClass="all-y-padding-three" title={model.subtitlePOIs} walkScoreModel={walkScoreModel}>
              <NearbyPOIs nearbyPOIsList={model.nearbyPOIs} />
            </NearbyList>
          )}
          {nearbyTransportation && (
            <NearbyList outerClass="all-y-padding-three" title={model.subtitleTransportations}>
              <NearbyTransportation nearbyTransportationList={model.nearbyTransportation} />
            </NearbyList>
          )}
          {nearbyRestaurants && (
            <NearbyList outerClass="all-t-padding-three" title={model.subtitleRestaurants}>
              <NearbyRestaurants nearbyRestaurantsList={model.restaurants} />
            </NearbyList>
          )}
        </UitkCardTextSegment>
      )}
    </div>
  );
};

WhatsAroundContent.displayName = 'WhatsAroundContent';
